import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { useState } from 'react'
import cx from 'classnames'
import Styles from './Chrome.module.scss'

interface Props {
  picture: string
  className?: string
}

export const Avatar = ({ picture, className }: Props) => {
  const [imageFailed, setImageFailed] = useState(false)

  if (imageFailed) {
    return <img className={cx(className, Styles.avatar)} src={Silhouette} alt="Avatar" />
  }

  return (
    <img className={cx(className, Styles.avatar)} src={picture} alt="Avatar" onError={() => setImageFailed(true)} />
  )
}
